<template>
  <div class="container">
    <b-row>
      <b-col>
        <Visualizar />
      </b-col>
    </b-row>

    <b-row class="row-button">
      <b-col class="one">
        <Help
          :title="title"
          :text="text"
          :uno="uno"
          :dos="dos"
          :tres="tres"
          :cuatro="cuatro"
          :text_eleven="text_eleven"
          :text_twelve="text_twelve"
        />
      </b-col>
      <b-col class="btn-direction-flex">
        <b-button
          @click="guardarBorrador"
          pill
          variant="primary"
          class="btn-one"
          v-if="userPermissions"
        >
          Guardar como borrador
        </b-button>
        <b-button
          @click="guardarFinalizado"
          pill
          variant="primary"
          class="btn-two"
          v-if="userPermission"
        >
          Guardar y finalizar
        </b-button>
      </b-col>
    </b-row>

    <b-row>
      <b-col class="title">
        <h5>Desafíos</h5>
      </b-col>
    </b-row>

    <b-row v-if="userPermissions" class="Checkbox-form">
      <b-form-checkbox
        style="display:flex;   justify-content: flex-end; "
        v-model="checked"
        name="check-button"
        switch
      >
        <span class="span" v-if="checked"> No Aplica</span>
        <span class="span" v-else>No Aplica</span>
      </b-form-checkbox>
    </b-row>

    <b-row>
      <div v-if="checked">
        <AlertError />
      </div>

      <div v-else>
        <CkEditorText :modifyContent="modifyContent" :borrador="borrador" />
      </div>
    </b-row>
  </div>
</template>

<script>
import Visualizar from "../../../../components/button/escritorio/Visualizar.vue";
import Help from "../../../../components/tools/Modal";
import CkEditorText from "../../../../components/private/CkEditorText";
import axios from "axios";
import Swal from "sweetalert2";
import { showAlert } from "../../../../components/tools/utils";
import AlertError from "../../../../components/error/AlertError.vue";

export default {
  props: ["userPermissions", "userPermission"],

  components: {
    Visualizar,
    Help,
    CkEditorText,
    AlertError,
  },
  data() {
    return {
      content: "",
      nombre: "Desafios",
      borrador: "",
      title: "Desafíos",
      text:
        "Presentar los desafíos institucionales más relevantes para el período de gobierno (2018-2022) y que, en opinión de la actual Dirección del Servicio, resulte altamente recomendable abordar. Para estos efectos, se priorizarán aquellas iniciativas que tengan un efecto directo en el cumplimiento de las funciones legales del Servicio o en los usuarios, beneficiarios o ciudadanos.",
      text_One:
        "Para esto, se deben describir brevemente los desafíos recomendados para el período 2018-2022, priorizando aquellos que pudiesen estar relacionados con:",
      uno:
        "Fortalecer alguna función del esencial del Servicio, para lo cual sea necesario realizar algún cambio normativo, generar una nueva iniciativa o programa, introducir mayor inteligencia en los servicios mediante tecnología, cubrir algún área que actualmente no se está abordando, entre otras.",
      dos:
        "Mejorar, modernizar u optimizar aspectos relacionados a las áreas de soporte de la institución que permitirán una mayor eficiencia y/o eficacia en la gestión del Servicio.",
      tres:
        "Iniciativas, proyectos o programas de alta importancia y que se encuentran actualmente en ejecución, para los cuales se recomienda mantener los esfuerzos institucionales que garanticen su correcta ejecución.",
      cuatro: "Otros que se consideren relevantes.",
      text_eleven:
        "En caso de que lo amerite, el desafío recomendado se debe sustentar a través de alguna evidencia objetiva. Para esto, es altamente recomendable que sea sustentado mediante antecedentes cuantitativos, apoyados en tablas o gráficos, y que señale los recursos que se destinarán en concordancia con los recursos aprobados en la Ley de Presupuesto 2021, o que se requerirán en los años del período 2018-2022.",
      checked: false,

      datosUser: null,
    };
  },

  methods: {
    modifyContent: function(text) {
      this.content = text;
    },
    buildData: function(type) {
      return {
        nombre: "desafios",
        elaboracion: type,
        data: {
          content: this.content,
          aplica: this.checked,
        },
        anio: process.env.VUE_APP_ANIO,
        idServicio: this.$route.params.idServicio,
      };
    },
    guardarBorrador: async function() {
      try {
        const toSend = this.buildData("borrador");

        await axios.post(
          `${process.env.VUE_APP_RUTA_API}/instituciones/secciones/`,
          toSend,
          {
            headers: {
              Authorization: `JWT ${localStorage.getItem("userToken")}`,
            },
          }
        );
        showAlert({
          icon: "success",
          text: "Guardado como Borrador Exitoso",
          timerProgressBar: true,
          timer: 3000,
        });
      } catch (error) {
        if (error.response.status === 422) {
          const toSend = {
            nombre: "desafios",
            elaboracion: "borrador",
            data: {
              content: this.content,
              aplica: this.checked,
            },
            anio: process.env.VUE_APP_ANIO,
          };

          await axios.put(
            `${process.env.VUE_APP_RUTA_API}/instituciones/secciones/${this.$route.params.idServicio}/`,
            toSend,
            {
              headers: {
                Authorization: `JWT ${localStorage.getItem("userToken")}`,
              },
            }
          );
          showAlert({
            icon: "success",
            text: "Guardado como Borrador Exitoso",
            timerProgressBar: true,
            timer: 3000,
          });
        } else {
          console.log(error);
          showAlert({
            icon: "error",
            text: error.response.data[Object.keys(error.response.data)[0]],
            timerProgressBar: true,
            timer: 3000,
          });
        }
      }
    },

    guardarFinalizado: async function() {
      Swal.fire({
        title: "Guardar y Finalizar",
        text: "¿Desea guardar el documento?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        cancelButtonText: "Cancelar",
        confirmButtonText: "Confirmar",
      }).then(async (result) => {
        if (result.isConfirmed) {
          try {
            const toSend = this.buildData("finalizado");

            await axios.post(
              `${process.env.VUE_APP_RUTA_API}/instituciones/secciones/`,
              toSend,
              {
                headers: {
                  Authorization: `JWT ${localStorage.getItem("userToken")}`,
                },
              }
            );
            showAlert({
              icon: "success",
              text: "Guardando documento",
              timerProgressBar: true,
              timer: 3000,
            });
          } catch (error) {
            if (error.response.status === 422) {
              const toSend = {
                nombre: "desafios",
                elaboracion: "finalizado",
                data: {
                  content: this.content,
                  aplica: this.checked,
                },
                anio: process.env.VUE_APP_ANIO,
              };

              await axios.put(
                `${process.env.VUE_APP_RUTA_API}/instituciones/secciones/${this.$route.params.idServicio}/`,
                toSend,
                {
                  headers: {
                    Authorization: `JWT ${localStorage.getItem("userToken")}`,
                  },
                }
              );
              showAlert({
                icon: "success",
                text: "Guardado y finalizado exitosamente.",
                timerProgressBar: true,
                timer: 3000,
              });
            } else {
              console.log(error);
              showAlert({
                icon: "error",
                text: error.response.data[Object.keys(error.response.data)[0]],
                timerProgressBar: true,
                timer: 3000,
              });
            }
          }
          this.$router.push({
            name: "buttons",
            params: { idUsuario: this.usuario.id },
          });
        }
      });
    },
    obtenerBorrador: async function() {
      try {
        const obj = {
          anio: process.env.VUE_APP_ANIO,
          nombre: "desafios",
        };
        const res = await axios.get(
          `${process.env.VUE_APP_RUTA_API}/instituciones/secciones/${this.$route.params.idServicio}/?anio=${obj.anio}&nombre=${obj.nombre}`,
          {
            headers: {
              Authorization: `JWT ${localStorage.getItem("userToken")}`,
            },
          }
        );

        res.data.info= res.data.info || {}
        this.checked = res.data.info.aplica || false;

        if (res.data) {
          this.borrador = res.data.info.content;
          console.log("Borrador", this.borrador)
        }
      } catch (error) {
        console.log(error);
      }
    },
  },
  mounted() {
    this.obtenerBorrador();
    this.obtenerRelacionUsuarioServicio();
  },
};
</script>

<style scoped>
.row {
  margin: 0;
}

.Checkbox-form {
  display: flex;
  justify-content: flex-end;
}
.btn-one {
  margin-right: 20px;
}

.btn-direction-flex {
  text-align: end;
}

.title {
  margin-top: 20px;
  text-align: center;
  color: #052333;
}

.title > h5 {
  font-weight: bold;
}

.row-button {
  margin-bottom: 30px;
}

.custom-control-input {
  width: 21px;
}

.row-checkbox {
  display: flex;
}

.span {
  font-size: 18px;
  color: #052333;
  font-weight: 600;
  display: grid;
  top: -10px;
}
@media screen and (max-width: 784px) {
  .btn-one {
    font-size: 11px;
    margin-right: 5px;
  }
  .btn-two {
    font-size: 11px;
  }
}

@media screen and (max-width: 569px) {
  .btn-one {
    font-size: 10px;
    margin-right: 5px;
    width: 90px;
  }
  .btn-two {
    font-size: 10px;
    width: 90px;
  }
}

@media screen and (max-width: 417px) {
  .one {
    display: none;
  }
  .btn-one {
    font-size: 10px;
    margin-right: 5px;
    width: 90px;
    margin-bottom: 15px;
  }
  .btn-two {
    font-size: 10px;
    width: 90px;
    position: relative;
    top: -6px;
  }
  .btn-direction-flex {
    text-align: start;
    margin-left: 30px;
  }
}
</style>
